import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Tagihan ")
const _hoisted_2 = { class: "font-semibold text-14px" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" dengan STT ")
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" berhasil dibayar dengan ")
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogPaymentLayoutHeader = _resolveComponent("DialogPaymentLayoutHeader")!
  const _component_DialogPaymentLayoutImage = _resolveComponent("DialogPaymentLayoutImage")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_DialogPaymentLayoutButton = _resolveComponent("DialogPaymentLayoutButton")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DialogPaymentLayoutHeader, { textHeader: "Pembayaran Berhasil" }, {
      "sub-header": _withCtx(() => [
        _hoisted_1,
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.billAmount), 1),
        (_ctx.billType === 'booking')
          ? (_openBlock(), _createBlock("span", _hoisted_3, [
              _hoisted_4,
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.sttNumber), 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_6,
        _hoisted_7,
        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.paidWith), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_DialogPaymentLayoutImage, { image: "payment-success-illustration" }),
    _createVNode(_component_DialogPaymentLayoutButton, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_button_fill, {
            onClick: _ctx.successPayment,
            title: "Selesai",
            custom: "w-48",
            style: {"height":"40px"}
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ], 64))
}